import MYDetailContainer from './MYDetailContainer';

/*
* MY페이지에서 더 자세한 정보를 눌렀을 때의 페이지
*/
export default MYDetailContainer;